import { defaultApi } from '@/plugins/api/defaultApi'
import { defaultV2Api } from '@/plugins/api/defaultV2Api'
import $cookies from '@/plugins/vueCookies'
import { referreCodeName } from '@/router/_interceptor/utm'

const getUtm = () => {
  return $cookies.get('bn_utm')
}

export default {
  name: 'signup',
  namespaced: true,
  state: {
    registerForm: null,
  },
  getters: {
    getRegisterForm(state) {
      return state.registerForm
    },
  },
  mutations: {
    setRegisterForm(state, form) {
      state.registerForm = form
    },
  },
  actions: {
    async emailDuplicate({}, email) {
      // true 타입과 일치시 중복
      const { data } = await defaultApi.emailDuplicate(email)
      return data?.isDuplicated === true
    },
    async phoneDuplicate({}, phone) {},
    async getVerificationCode({}, phone) {
      const { data } = await defaultApi.getVerificationCode(phone)
      return data
    },
    async confirmVerificationCode({}, verificationCodeForm) {
      // true 타입과 일치시 유효함
      const { data } = await defaultApi.confirmVerificationCode(verificationCodeForm)
      return data?.isValid === true
    },
    async signup({ commit }, form = { register }) {
      let result = null
      const param = {
        ...form.register,
        referralCode: $cookies.get(referreCodeName),
      }

      try {
        const utm = getUtm()
        if (utm) {
          param['utm'] = utm
        }
      } catch (e) {
        console.error(e)
      }

      const { data } = await defaultApi.signup(param)
      result = data

      commit('setRegisterForm', null)
      return result
    },
    async affiliatesSignup({}, userForm) {
      try {
        const utm = getUtm()
        if (utm) {
          userForm['utm'] = utm
        }
      } catch (e) {
        console.error(e)
      }
      const { data } = await defaultApi.affiliatesRegistration(userForm)
      return data
    },
    async tempSignup({}, body) {
      const { data } = await defaultApi.postTempSignup(body)
      return data
    },
    async onlyPhoneDuplicate({}, phone) {
      const { data } = await defaultV2Api.onlyPhoneDuplicate(phone)
      return data
    },
  },
}
